import cx from "classnames";
import React from "react";
import { connect } from "react-redux";
import { SEO } from "~/components/common/molecules/SEO";
import BannerHome from "~/components/desktop/molecules/BannerHome";
import AdvanceMedPro from "~/components/desktop/organisms/AdvanceMedPro";
import FeatureHospital from "~/components/desktop/organisms/FeatureHospital";
import FeatureMedPro from "~/components/desktop/organisms/FeatureMedPro";
import SupportMedPro from "~/components/desktop/organisms/SupportMedPro";
import { clearState } from "~/store/patient/patientAction";
import { HospitalStepOnePatient } from "~/utils/constants";
import AppId, { findPartner } from "~/utils/partner";
import DeployedHospital from "../../molecules/DeployedHospital";
import { NewsAndEvents } from "../../molecules/NewsAndEvents";
import AdServices from "../../organisms/AdServices";
import styles from "./style.module.scss";
const partner = findPartner();
class HomePage extends React.Component {
  state = {
    lastScrollY: 0,
    scrollingDown: false
  };

  componentDidMount() {
    if (HospitalStepOnePatient.includes(AppId)) {
      this.props.clearStatePatient();
    }
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > this.state.lastScrollY;

    this.setState({
      lastScrollY: currentScrollY,
      scrollingDown
    });
  };

  componentDidUpdate() {
    if (HospitalStepOnePatient.includes(AppId)) {
      this.props.clearStatePatient();
    }
    if (
      (this.props.history.location.state &&
        this.props.history.location.state.scrollToDownload) ||
      this.props.history.location.hash === "#download_application"
    ) {
      let downloadSection = window.document.getElementById(
        "download_application"
      );
      if (downloadSection) {
        let height = 0;
        do {
          height += downloadSection.offsetTop;
          downloadSection = downloadSection.offsetParent;
        } while (downloadSection);
        window.scrollTo({
          top: height - 200,
          behavior: "smooth"
        });
        this.props.history.replace();
      }
    }
  }

  render() {
    const featureNode =
      AppId !== "medpro" ? (
        <React.Fragment>
          <SEO
            title={partner.seo_title}
            meta={[
              {
                name: `description`,
                content: partner?.seo_description
              },
              {
                property: `og:title`,
                content: "Trang chủ"
              }
            ]}
          />
          <FeatureHospital />
          <AdServices />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <AdvanceMedPro />
          <FeatureMedPro />
        </React.Fragment>
      );

    const listApiHaveNews = ["medpro"];
    const { scrollingDown } = this.state;
    return (
      <div className={cx(styles.bg_page, !scrollingDown && styles.showTop)}>
        <h1 className={styles.contentPage}>
          {partner.seo_title || "Medpro - Đặt lịch khám bệnh"}
        </h1>
        <BannerHome />
        {/* chỉ có medpro.com mói có danh sách bệnh viện được triển khai */}
        {AppId === "medpro" ? <DeployedHospital /> : null}
        {featureNode}

        {/* danh sách bệnh viện có tin tức  */}
        {listApiHaveNews.includes(AppId) ? <NewsAndEvents /> : null}
        <SupportMedPro />
        <div id="firebaseui-auth-container" style={{ display: "none" }} />
        {/* Button PhoneNumber  */}
        <a href="tel:19002115">
          <div className={styles.support}>
            <i className="fa fa-phone fa-flip-horizontal" />
          </div>
        </a>
      </div>
    );
  }
}
const mapDispatchToProps = {
  clearStatePatient: clearState
};

export default connect(null, mapDispatchToProps)(HomePage);
